import { AxiosError } from 'axios';
import Api from "configs";
import { useQuery } from "@tanstack/react-query";
import GetResponse from 'types/GetResponse';
import GetFilters from 'types/GetFilter';

export const useGetReport = (filters: GetFilters) => {
    const {
        pageSize = 10,
        page = 1,
        search
    } = filters;
    const options = {
        query: {
          
        },
        pageSize: pageSize,
        page: page
    }
    if(search){
        options.query = {
         ...options.query,
            search: search
        }
    }
    return useQuery<GetResponse, AxiosError>({
        queryKey: ['useGetReport', options], 
        queryFn: async () => {
            const { data } = await Api.get('/reports', { params: options });
            return data;
        },
        staleTime: 1000 * 60 * 5
    });
}

export const useGetCustomerReviews = (filters: any) => {
    const { pageSize = 10, page = 1, search = '' } = filters;
    return useQuery<any, AxiosError>({
        queryKey: ['useGetCustomerReviews', { page, pageSize, search }],
        queryFn: async () => {
            const { data } = await Api.get('/reviews/customer-reviews', {
                params: { page, pageSize, search },
            });
            return data;
        },
        staleTime: 1000 * 60,
    });
};

export const useGetShopClosedReports = (filters: any) => {
    const { pageSize = 10, page = 1, search = '', status = 'all' } = filters;
    return useQuery<any, AxiosError>({
        queryKey: ['useGetShopClosedReports', { page, pageSize, search, status }],
        queryFn: async () => {
            const { data } = await Api.get('/shops/closed-reports', {
                params: { page, pageSize, search, status },
            });
            return data;
        },
        staleTime: 1000 * 30,
    });
};